export enum ColorsNonProd {
  Main = 'lime',
  Secondary = '#daffda',
}
